'use strict';

import React from 'react';
import moment from "moment";
import { OnSchedUtils } from '../../../../../utils';
import { GetAvailability } from '../../../../../actions/availabilityActions';


const Day = ({ element, week, date, disabled, timezoneName, setDate, setAvailability }) => {
  const active = date === week.format('YYYY-MM-DD');

  const clickChangeDay = () => {
    if (!disabled) {
      if (moment(week).format('YYYY-MM-DD') !== date) {
        OnSchedUtils.Loading(element, true, 'Availability');
        GetAvailability(element, moment(week).format('YYYY-MM-DD'), timezoneName)
          .then(response => {
            setAvailability(response);
            setDate(moment(week).format('YYYY-MM-DD'));
            OnSchedUtils.Loading(element, false);
          })
      }
      // OnAvailableDaySelect = ({element, instance, date, initialDate, timezoneName, setDate, setAvailability}) => {
      // OnSchedUtils.OnAvailableDaySelect({ element, date: week.format('YYYY-MM-DD'), initialDate: date, timezoneName, setDate, setAvailability })
    }
  }

  return (
    <div onClick={clickChangeDay} className={`Day ${!disabled ? 'onsched-dark-color onsched-primary-color-hover' : 'onsched-border-color disabled'}`}>
      <h5 className={`${active && !disabled ? 'onsched-primary-color' : ''}`}><span className='short'>{moment(week).format('dd').slice(0,1)}</span><span className='long'>{moment(week).format('ddd')}</span></h5>
      <h5 className={`${active && !disabled ? 'onsched-primary-background-color onsched-background-color' : ''}`}>{moment(week).format('DD')}</h5>
    </div>
  )
}

export default Day
